<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <h5 class="mb-0"><i class="fa fa-fw fa-wrench mr-2" />Adjustment Kerusakan</h5>
            <hr />
            <b-row>
                <b-col md="2">
                    <b-form-group label="Jenis">
                        <multiselect v-model="filter.kind"
                            label="name"
                            track-by="id"
                            :internal-search="true"
                            deselect-label=""
                            select-label=""
                            :options="optKind"
                            @input="onChangeFilterKind"
                        />
                    </b-form-group>
                </b-col>
                <b-col md="2">
                    <b-form-group label="Kategori">
                        <multiselect v-model="filter.category"
                            label="name"
                            track-by="id"
                            :internal-search="true"
                            deselect-label=""
                            select-label=""
                            :options="optFilterCategory"
                            :disabled="optFilterCategory.length <= 0"
                        />
                    </b-form-group>
                </b-col>
                <b-col md="2">
                    <b-form-group label="Nama">
                        <b-form-input v-model="filter.name" maxlength="50" @keydown.enter="getItems" />
                    </b-form-group>
                </b-col>
                <b-col md="3">
                    <b-form-group label="Aksi">
                        <b-button variant="primary" @click="getItems()">
                            <i class="fa fa-search mr-2" />Cari
                        </b-button>
                        <b-button class="ml-2 btn-dark" @click="downloadMasterAdjustment()">
                            <i class="fa fa-download mr-2" />Download
                        </b-button>
                    </b-form-group>
                </b-col>
                <b-col md="3" class="text-right">
                    <b-form-group label="Tambah">
                        <b-button variant="success" @click="$bvModal.show('m-create')">
                            <i class="fa fa-plus mr-2" />Adjustment Baru
                        </b-button>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-table bordered hover show-empty no-local-sorting
                :busy="isBusy"
                :items="items"
                :fields="fields"
                @sort-changed="onSortChanged"
                responsive class="mb-3"
            >
                <template v-slot:empty>
                    Tidak ada data adjustment kerusakan.
                </template>
                <template v-slot:cell(category)="row">
                    {{ row.item.category_name }}
                </template>
                <template v-slot:cell(kind)="row">
                    {{ row.item.item_kind_name }}
                </template>
                <!-- <template v-slot:cell(adjustment)="row">
                    <span v-if="!row.item.adjustment">{{ Number(row.item.adjustment_percentage).toFixed(2) }}%</span>
                    <span v-else>Rp. {{ $helper.formatThousand(row.item.adjustment) }}</span>
                </template> -->
                <template v-slot:cell(action)="row">
                    <b-button size="sm" variant="warning" class="mr-2" v-b-tooltip.hover.top title="Edit" @click="prepareEdit(row.item)">
                        <i class="fa fa-fw fa-pencil" />
                    </b-button>
                    <b-button size="sm" variant="danger" v-b-tooltip.hover.top title="Delete" @click="prepareDelete(row.item)">
                        <i class="fa fa-fw fa-times" />
                    </b-button>
                </template>
            </b-table>
            <PageSizer :totalRows="totalRows" :page="currentPage" :options="options" @limit-change="onLimitChange" @page-change="onPageChange" />
        </b-card>
        <b-modal id="m-create" title="Tambah Adjustment Baru" no-close-on-backdrop no-close-on-esc hide-footer>
            <b-form-group label="Jenis Barang">
                <multiselect v-model="input.kind"
                    label="name"
                    track-by="id"
                    :internal-search="true"
                    deselect-label=""
                    select-label=""
                    :options="optKind"
                    @input="onChangeInputKind"
                />
            </b-form-group>
            <b-form-group label="Kategori Barang">
                <multiselect v-model="input.category"
                    label="name"
                    track-by="id"
                    :internal-search="true"
                    deselect-label=""
                    select-label=""
                    :options="optInputCategory"
                    :disabled="optInputCategory.length <= 0"
                />
            </b-form-group>
            <b-form-group label="Nama Adjustment">
                <b-input v-model="input.name" maxlength="100" />
            </b-form-group>
            <!-- <b-form-group label="Adjustment Harga (Nominal)">
                <b-input-group prepend="Rp.">
                    <b-form-input v-model="input.adjustment" @input="sanitize(input)" :disabled="input.adjustmentPercentage != ''" maxlength="50" />
                </b-input-group>
            </b-form-group>
            <b-form-group label="Adjustment Harga (Persentase)">
                <b-input-group append="%">
                    <b-form-input v-model="input.adjustmentPercentage" :disabled="input.adjustment != ''" maxlength="50" />
                </b-input-group>
            </b-form-group> -->
            <div class="mt-4 text-right">
                <b-button variant="primary" :disabled="isSubmitting" @click="confirmCreate">
                    {{ isSubmitting ? "Menyimpan..." : "Simpan" }}
                </b-button>
            </div>
        </b-modal>
        <b-modal id="m-edit" title="Edit Adjustment" no-close-on-backdrop no-close-on-esc hide-footer>
            Mengubah adjustment <strong>{{ activeItem.name }}</strong> ({{ activeItem.category_name }}, {{ activeItem.item_kind_name }})
            <b-form-group label="Jenis Barang">
                <multiselect v-model="edit.kind"
                    label="name"
                    track-by="id"
                    :internal-search="true"
                    deselect-label=""
                    select-label=""
                    :options="optKind"
                    @input="onChangeEditKind"
                    disabled
                />
            </b-form-group>
            <b-form-group label="Kategori Barang">
                <multiselect v-model="edit.category"
                    label="name"
                    track-by="id"
                    :internal-search="true"
                    deselect-label=""
                    select-label=""
                    :options="optEditCategory"
                    disabled
                />
            </b-form-group>
            <b-form-group label="Nama Adjustment" class="mt-4">
                <b-input v-model="edit.name" maxlength="100" />
            </b-form-group>
            <!-- <b-form-group label="Adjustment Harga (Nominal)">
                <b-input-group prepend="Rp.">
                    <b-form-input v-model="edit.adjustment" @input="sanitize(input)" :disabled="edit.adjustmentPercentage != ''" maxlength="50" />
                </b-input-group>
            </b-form-group>
            <b-form-group label="Adjustment Harga (Persentase)">
                <b-input-group append="%">
                    <b-form-input v-model="edit.adjustmentPercentage" :disabled="edit.adjustment != ''" maxlength="50" />
                </b-input-group>
            </b-form-group> -->
            <div class="mt-4 text-right">
                <b-button variant="primary" :disabled="isSubmitting" @click="confirmEdit">
                    {{ isSubmitting ? "Menyimpan..." : "Simpan" }}
                </b-button>
            </div>
        </b-modal>
        <b-modal id="m-delete" title="Delete Adjustment" no-close-on-backdrop no-close-on-esc hide-footer>
            Anda yakin ingin menghapus adjustment <strong>{{ activeItem.name }}</strong> ({{ activeItem.item_kind_name }})?
            <div class="mt-4 text-right">
                <b-button variant="outline-primary" class="mr-2" :disabled="isSubmitting" @click="$bvModal.hide('m-delete')">
                    Batal
                </b-button>
                <b-button variant="danger" :disabled="isSubmitting" @click="confirmDelete">
                    {{ isSubmitting ? "Menghapus..." : "Hapus" }}
                </b-button>
            </div>
        </b-modal>
        <b-modal id="m-download" title="Master Kerusakan" centered no-close-on-backdrop no-close-on-esc hide-footer>
            <div v-if="status == 0">
                Menyiapkan file Excel, mohon menunggu...
            </div>
            <div v-else-if="status == -1">
                Gagal menyiapkan file Excel.
            </div>
            <div v-else>
                File Excel sudah siap. Tekan tombol dibawah ini untuk download file Excel.
                <div class="mt-2">
                    <a :href="$BASE_FILE_PATH + path" download>
                        <b-button variant="primary">
                            <i class="fa fa-download mr-2" />Download Master Kerusakan
                        </b-button>
                    </a>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    data() {
        return {

            initStatus: 0,
            isBusy: true,
            isSubmitting: false,
            show: 10,

            filter: {
                kind: null,
                category: null,
                name: ""
            },

            input: {
                kind: null,
                category: null,
                name: "",
                // adjustment: "",
                // adjustmentPercentage: ""
            },

            edit: {
                kind: null,
                category: null,
                name: "",
                // adjustment: "",
                // adjustmentPercentage: ""
            },

            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],

            fields: [
                { key: "kind", label: "Jenis Barang", sortable: true },
                { key: "category", label: "Kategori Kerusakan", sortable: true },
                { key: "name", label: "Keterangan", sortable: true },
                // { key: "adjustment", label: "Adjustment Harga" },
                { key: "action", label: "Aksi" },
            ],

            items: [],
            activeItem: {
                id: null
            },
            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            sortBy: null,
            sortDesc: false,

            optKind: [],
            optFilterCategory: [],
            optInputCategory: [],
            optEditCategory: [],

            status: 0,

        }
    },

    methods: {

        init() {

            this.initStatus = 0

            if(this.filter.kind != null){
                this.$axios.get("category/selection?item_kind_id=" + this.filter.kind.id).then(res => {
                    this.optFilterCategory = res.data.data
                })
            }

            let getItems = this.getItems()

            let getMasterKind = this.$axios.get("master/kinds").then(res => {
                this.optKind = res.data.data
            })

            Promise.all([getItems, getMasterKind]).then(() => {
                this.initStatus = 1
            })
            .catch(error => {
                this.initStatus = -1
            })

        },

        confirmCreate() {

            if(this.input.kind == null) {
                return this.$helper.toastError(this, "Jenis barang tidak boleh kosong!")
            }

            if(this.input.category == null) {
                return this.$helper.toastError(this, "Kategori barang tidak boleh kosong!")
            }

            if(this.$helper.isBlank(this.input.name)) {
                return this.$helper.toastError(this, "Nama tidak boleh kosong!")
            }

            // if(this.$helper.isBlank(this.input.adjustment) && this.$helper.isBlank(this.input.adjustmentPercentage)) {
            //     return this.$helper.toastError(this, "Adjustment harga tidak boleh kosong!")
            // }

            let isConfirmed = confirm("Simpan adjustment kerusakan baru ini?")
            if(!isConfirmed) return

            let payload = {
                name: this.input.name,
                item_kind_id: this.input.kind.id,
                category_id: this.input.category.id
            }

            // if(!this.$helper.isBlank(this.input.adjustment)){
            //     payload['adjustment'] = this.$helper.toNumber(this.input.adjustment)
            //     payload['is_percentage'] = false
            // }

            // if(!this.$helper.isBlank(this.input.adjustmentPercentage)){
            //     payload['adjustment_percentage'] = parseFloat(this.input.adjustmentPercentage.replace(',','.').replace(' ',''))
            //     payload['is_percentage'] = true
            // }

            this.isSubmitting = true
            this.$axios.post("adjustment", payload).then(res => {

                this.$helper.toastSuccess(this, "Adjustment baru berhasil ditambahkan!")
                this.$bvModal.hide("m-create")
                this.input.name = ""
                this.input.category = null
                this.input.kind = null
                // this.input.adjustment = ""
                // this.input.adjustmentPercentage = ""
                this.getItems(this.currentPage)

            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        },

        prepareEdit(item) {
            this.activeItem = item
            this.edit.kind = {
                id: item.item_kind_id,
                name: item.item_kind_name
            }
            this.edit.category = {
                id: item.category_id,
                name: item.category_name
            }
            this.edit.name = item.name
            // this.edit.adjustment = item.adjustment ? item.adjustment : ""
            // this.edit.adjustmentPercentage = item.adjustment_percentage ? item.adjustment_percentage : ""
            this.$bvModal.show("m-edit")
        },

        confirmEdit() {

            if(this.$helper.isBlank(this.edit.name)) {
                return this.$helper.toastError(this, "Nama tidak boleh kosong!")
            }

            if(this.edit.kind == null) {
                return this.$helper.toastError(this, "Jenis barang tidak boleh kosong!")
            }

            // if(this.$helper.isBlank(this.edit.adjustment) && this.$helper.isBlank(this.edit.adjustmentPercentage)) {
            //     return this.$helper.toastError(this, "Adjustment harga tidak boleh kosong!")
            // }

            let isConfirmed = confirm("Simpan perubahan adjustment ini?")
            if(!isConfirmed) return

            let payload = {
                name: this.edit.name,
                item_kind_id: this.edit.kind.id,
                category_id: this.edit.category.id
            }

            // if(!this.$helper.isBlank(this.edit.adjustment)){
            //     payload['adjustment'] = this.$helper.toNumber(this.edit.adjustment)
            //     payload['is_percentage'] = false
            // }

            // if(!this.$helper.isBlank(this.edit.adjustmentPercentage)){
            //     payload['adjustment_percentage'] = parseFloat(this.edit.adjustmentPercentage.replace(',','.').replace(' ',''))
            //     payload['is_percentage'] = true
            // }

            this.isSubmitting = true
            this.$axios.post("adjustment/" + this.activeItem.id, payload).then(res => {

                this.$helper.toastSuccess(this, "Data adjustment berhasil diubah!")
                this.$bvModal.hide("m-edit")
                this.edit.name = ""
                this.edit.kind = null
                // this.edit.adjustment = ""
                // this.edit.adjustmentPercentage = ""
                this.getItems(this.currentPage)

            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        },
        
        prepareDelete(item) {
            this.activeItem = item
            this.$bvModal.show("m-delete")
        },

        confirmDelete() {

            let isConfirmed = confirm("Apakah anda yakin ingin menghapus adjustment kerusakan ini? Perubahan ini tidak dapat dibatalkan!")
            if(!isConfirmed) return

            this.isSubmitting = true

            this.$axios.delete("adjustment/" + this.activeItem.id).then(res => {

                this.$helper.toastSuccess(this, "Data adjustment berhasil dihapus!")
                this.$bvModal.hide("m-delete")
                this.getItems()

            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        },

        getItems(page = 1) {

            this.isBusy = true
            this.items = []

            if(isNaN(page)) {
                this.currentPage = 1
            }
            else {
                this.currentPage = page
            }

            // URL builder
            let param = this.$helper.getBasePagedQuery(this.currentPage, this.perPage)

            if(this.filter.kind != null) {
                param += "&filterKind=" + this.filter.kind.id
            }

            if(this.filter.category != null) {
                param += "&filterCategory=" + this.filter.category.id
            }

            if(!this.$helper.isBlank(this.filter.name)) {
                param += "&filterName=" + this.filter.name
            }

            if(!this.$helper.isBlank(this.sortBy)) {
                if(this.sortBy == 'kind') param += "&sortBy=item_kind_name"
                else if(this.sortBy == 'category') param += "&sortBy=category_name"
                else param += "&sortBy=" + this.sortBy
                param += "&sortDesc=" + this.sortDesc
            }

            return this.$axios.get("adjustment" + param).then(res => {
                this.items = res.data.data.items
                this.totalRows = res.data.data.total
                sessionStorage.setItem("adjustmentKerusakanFilter", JSON.stringify(this.filter))
            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isBusy = false
            })

        },

        onLimitChange(newPerPage) {
            this.perPage = newPerPage
            this.getItems(this.currentPage)
        },

        onPageChange(newPage) {
            this.currentPage = newPage
            this.getItems(this.currentPage)
        },

        onSortChanged(ctx) {
            this.sortBy = ctx.sortBy
            this.sortDesc = ctx.sortDesc
            this.getItems()
        },
        
        onChangeFilterKind() {
            this.filter.category = null
            if(this.filter.kind == null){
                this.optFilterCategory = []
            }
            else {
                this.$axios.get("category/selection?item_kind_id=" + this.filter.kind.id).then(res => {
                    this.optFilterCategory = res.data.data
                })
            }
        },

        onChangeInputKind() {
            this.input.category = null
            if(this.input.kind == null){
                this.optInputCategory = []
            }
            else {
                this.$axios.get("category/selection?item_kind_id=" + this.input.kind.id).then(res => {
                    this.optInputCategory = res.data.data
                })
            }
        },

        onChangeEditKind() {
            this.edit.category = null
            if(this.edit.kind == null){
                this.optEditCategory = []
            }
            else {
                this.$axios.get("category/selection?item_kind_id=" + this.edit.kind.id).then(res => {
                    this.optEditCategory = res.data.data
                })
            }
        },

        // sanitize(item) {

        //     let cleaned = String(item.adjustment).replace(/\./g, "")
        //     let res = cleaned.replace(/(?!^-)[^0-9]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
        //     item.adjustment = res

        // }

        downloadMasterAdjustment() {

            this.$bvModal.show("m-download")
            this.status = 0
            this.$axios.post("adjustment/download-excel-master", this.filter).then(res => {

                this.status = 1
                this.path = res.data.data.path

            })
            .catch(error => {
                this.status = -1
                this.$helper.parseError(this, error)
            })
        },

    },

    created() {
        if(!this.$helper.isBlank(sessionStorage.getItem("adjustmentKerusakanFilter"))){
            this.filter = JSON.parse(sessionStorage.getItem("adjustmentKerusakanFilter"))
        }
        this.init()
    }
}
</script>
